// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../../../client';
import PrimaryButton from '../../../../components/PrimaryButton';
import { __ } from '../../../../i18n/l10n';
import theme from '../../../../styled-components/dark';
import BetshareImageContainer from '../../../betshare/containers/BetshareImageContainer';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const StyledBetshareImageContainer = styled(BetshareImageContainer)`
  overflow-y: scroll;
`;

const AddButton = styled(PrimaryButton)`
  color: ${theme.BasketCtas.primary.color};
  background-color: ${theme.BasketCtas.primary.backgroundColor};
  margin: 0.6em;
  font-size: 1em;
  min-height: 2.6em;

  ${Target.__MOBILE__
    ? css`
        margin-bottom: 0.6em;
        margin-bottom: calc(0.6em + constant(safe-area-inset-bottom));
        margin-bottom: calc(0.6em + env(safe-area-inset-bottom));
      `
    : undefined}
`;

type BetslipOptionsAddToBasketModalProps = {
  className?: string;
  onAddToBasketClick: () => void;
  betslipReference: string;
  options?: {
    nickname?: string;
    stack?: boolean;
    showPseudo?: boolean;
  };
};

const BetslipOptionsAddToBasketModal = ({
  className = '',
  onAddToBasketClick,
  betslipReference,
  options,
}: BetslipOptionsAddToBasketModalProps) => {
  return (
    <Wrapper className={className}>
      <StyledBetshareImageContainer betslipReference={betslipReference} options={options} />
      <AddButton onClick={onAddToBasketClick}>{__('Add bet to basket')}</AddButton>
    </Wrapper>
  );
};

export default BetslipOptionsAddToBasketModal;
